/**
 * Editorial Board data scraped from:
 *  - https://www.mdpub.net/index.php?sec=editors
 *  - https://www.ejos.org/index.php?sec=editors
 *
 * Light text cleanup applied (extra duplicated lines removed, types
 * normalized). Source of truth remains the journal sites.
 */

export const EDITORIAL_BOARDS = {
  ijmrcr: {
    journalId: "ijmrcr",
    journalShort: "IJMRCR",
    journalTitle: "International Journal of Medical Reviews and Case Reports",
    issn: "ISSN: 2534-9821",
    journalUrl: "https://www.mdpub.net",
    sourceUrl: "https://www.mdpub.net/index.php?sec=editors",
    submitUrl: "https://www.ejmanager.com/my/ijmrcr/",
    groups: [
      {
        role: "Editor-in-Chief",
        members: [
          {
            name: "Ivan Inkov",
            affiliation:
              "ESCO Graduate, College of European School of Oncology; CAS in Lung Cancer (University of Zurich); CCB in Breast Cancer (Ulm University); Thoracic Surgery Fellow, Military Medical Academy of Sofia",
            country: "Bulgaria",
            orcid: "0000-0001-6084-1707",
          },
        ],
      },
      {
        role: "Statistics Editor",
        members: [
          {
            name: "Kalin Inkov",
            affiliation: "University of National and World Economy, Sofia",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Editorial Board Members",
        members: [
          {
            name: "Gennaro Cormio",
            affiliation:
              "Gynecologic Oncology Unit, Dept of Obstetrics & Gynaecology, University of Bari",
            country: "Italy",
          },
          {
            name: "I Putu Eka Widyadharma",
            affiliation:
              "Pain and Headache Division, Dept of Neurology, Udayana University, Bali",
            country: "Indonesia",
          },
          {
            name: "Refat Youssef",
            affiliation: "Biological Research Division, National Research Centre, Giza",
            country: "Egypt",
          },
          {
            name: "Andrea Sisti",
            affiliation: "Cleveland Clinic Ohio",
            country: "USA",
          },
          {
            name: "Antonio Simone Laganà",
            affiliation:
              "Unit of Gynecology and Obstetrics, University of Messina",
            country: "Italy",
          },
          {
            name: "Bashir A. Lwaleed",
            affiliation:
              "Associate Professor, Faculty of Health Sciences, University of Southampton",
            country: "UK",
          },
          {
            name: "N. S. Neki",
            affiliation:
              "Professor of Medicine, Government Medical College & Guru Nanak Dev Hospital, Amritsar",
            country: "India",
          },
          {
            name: "Alexander Berezin",
            affiliation:
              "Professor of Medicine, Consultant Cardiology Unit, State Medical University, Zaporozhye",
            country: "Ukraine",
          },
          {
            name: "Uma Hariharan",
            affiliation:
              "Assistant Professor Anaesthesia & Intensive Care, Dr Ram Manohar Lohia Hospital & PGIMER, New Delhi",
            country: "India",
          },
          {
            name: "George Baytchev",
            affiliation:
              "Head of Breast Unit, Dept of Thoracic Surgery, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Vitalii Rizov",
            affiliation: "Clinic of Cardiac Surgery, Prague",
            country: "Czechia",
          },
          {
            name: "Ivan Ivanov",
            affiliation: "Clinic of Pathology, Medical University of Pleven",
            country: "Bulgaria",
          },
        ],
      },
    ],
  },

  ijsm: {
    journalId: "ijsm",
    journalShort: "IJSM",
    journalTitle: "International Journal of Surgery and Medicine",
    issn: "E-ISSN: 2367-699X · P-ISSN: 2367-7414",
    journalUrl: "https://www.ejos.org",
    sourceUrl: "https://www.ejos.org/index.php?sec=editors",
    submitUrl: "https://www.ejmanager.com/my/ijsm/",
    groups: [
      {
        role: "Editor-in-Chief",
        members: [
          {
            name: "Ivan Inkov",
            affiliation:
              "ESCO Graduate, College of European School of Oncology; CAS in Lung Cancer (University of Zurich); CCB in Breast Cancer (Ulm University)",
            country: "Bulgaria",
            orcid: "0000-0001-6084-1707",
          },
        ],
      },
      {
        role: "Associate Editors",
        members: [
          {
            name: "Ventsislav Mutafchiyski",
            affiliation:
              "Head of Clinic of Endoscopic Endocrine Surgery and Coloproctology, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Adel Hamed Elbaih",
            affiliation:
              "Assistant Professor of Emergency Medicine, Faculty of Medicine, Suez Canal University, Ismailia",
            country: "Egypt",
            orcid: "0000-0002-3347-5163",
          },
          {
            name: "Arda Asik",
            affiliation:
              "Dept of General Surgical Oncology – Breast Surgery, Pittsburgh",
            country: "USA",
            orcid: "0000-0001-9493-4055",
          },
        ],
      },
      {
        role: "Assistant Editors",
        members: [
          {
            name: "Mila Kayryakova",
            affiliation: "Dept of Gynecology, MHAT Nadezhda, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Yoana Milusheva",
            affiliation:
              "Dept of Medical Oncology, University Hospital Tsaritsa Yoanna – ISUL, Sofia",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Abdominal Surgery & Coloproctology",
        members: [
          {
            name: "Georgi Popivanov",
            affiliation:
              "Clinic of Endoscopic Endocrine Surgery and Coloproctology, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Kirien Kjossev",
            affiliation:
              "Dept of General Surgery, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Laura Mora",
            affiliation:
              "Coloproctology Unit, Parc Tauli University Hospital, Barcelona",
            country: "Spain",
          },
          {
            name: "Roberto Chirocchi",
            affiliation:
              "General Surgery Department, Università degli Studi di Perugia",
            country: "Italy",
          },
          {
            name: "Franco Stagnitti",
            affiliation: "Sapienza University, Rome",
            country: "Italy",
          },
          {
            name: "Wagih Ghannam",
            affiliation:
              "General Surgery Department, Mansoura Faculty of Medicine",
            country: "Egypt",
          },
          {
            name: "Murat Özgür Kılıç",
            affiliation:
              "Numune Training and Research Hospital, Ankara",
            country: "Turkey",
          },
          {
            name: "Doğan Gönüllü",
            affiliation: "Kafkas University, School of Medicine, Kars",
            country: "Turkey",
          },
          {
            name: "Dennis Chung Kei Ng",
            affiliation:
              "Dept of Surgery, North District Hospital, Hong Kong SAR",
            country: "China",
          },
          {
            name: "Aikaterini Mastoraki",
            affiliation:
              "First Dept of Surgery, National and Kapodistrian University of Athens",
            country: "Greece",
          },
          {
            name: "Alessandro Pasculli",
            affiliation:
              "Academic General Surgery Unit, University Medical School of Bari",
            country: "Italy",
          },
          {
            name: "Evgeni Belokonski",
            affiliation:
              "Head of General Surgery Clinic, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Dronacharya Routh",
            affiliation:
              "Dept of GI Surgery, Command Hospital (WC), Chandimandir, Haryana",
            country: "India",
          },
        ],
      },
      {
        role: "Cardiovascular & Thoracic Surgery",
        members: [
          {
            name: "Atsushi Sano",
            affiliation:
              "Dept of Thoracic Surgery, Chigasaki Municipal Hospital",
            country: "Japan",
          },
          {
            name: "Tsvetomir Loukanov",
            affiliation:
              "Head of Clinic of Pediatric Cardiac Surgery, Universitätsklinikum Heidelberg",
            country: "Germany",
          },
          {
            name: "Fazli Yanik",
            affiliation:
              "Dept of Thoracic Surgery, Faculty of Medicine, Trakya University, Edirne",
            country: "Turkey",
          },
          {
            name: "George Kesov",
            affiliation:
              "Dept of Thoracic Surgery, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Plastic & Breast Surgery",
        members: [
          {
            name: "George Baytchev",
            affiliation:
              "Head of Breast Unit, Dept of Thoracic Surgery, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Iskra Daskalova",
            affiliation:
              "European Medical Center, Breast Center, Moscow",
            country: "Russia",
          },
          {
            name: "Hristo Lozanov",
            affiliation:
              "Dept of Plastic Surgery, Military Medical Academy, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Metehan Gumus",
            affiliation: "Dicle University",
            country: "Turkey",
          },
        ],
      },
      {
        role: "Neurosurgery",
        members: [
          {
            name: "Slavomir Kondoff",
            affiliation:
              "Head of Dept of Neurosurgery, Tokuda Hospital Sofia",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Orthopaedics",
        members: [
          {
            name: "Michele Bisaccia",
            affiliation:
              "Division of Orthopedics and Trauma Surgery, University of Perugia",
            country: "Italy",
          },
        ],
      },
      {
        role: "Obstetrics & Gynecology",
        members: [
          {
            name: "Slavcho Tomov",
            affiliation:
              "Obstetrics & Gynecology Clinic, Medical University of Pleven",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Clinical Medicine, Immunology & Oncology",
        members: [
          {
            name: "Kosta Kostov",
            affiliation:
              "Head of Clinic of Pulmonology, UMHAT St. Anna, Sofia",
            country: "Bulgaria",
          },
          {
            name: "Piotr Korczynski",
            affiliation:
              "Dept of Internal Medicine, Pulmonary Diseases and Allergy, Medical University of Warsaw",
            country: "Poland",
          },
          {
            name: "Rumen Popov",
            affiliation:
              "Center of Transfusional Hematology, Military Medical Academy of Sofia",
            country: "Bulgaria",
          },
          {
            name: "Viktoria Sarafian",
            affiliation:
              "Dept of Medical Biology, Medical University of Plovdiv",
            country: "Bulgaria",
          },
          {
            name: "Zhasmina Mihaylova",
            affiliation:
              "Head of Clinic of Medical Oncology, Military Medical Academy of Sofia",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Pathology",
        members: [
          {
            name: "Savelina Popovska",
            affiliation:
              "Head of Clinic of Pathology, Medical University of Pleven",
            country: "Bulgaria",
          },
        ],
      },
      {
        role: "Junior Editorial Board",
        members: [
          {
            name: "Efstratios Koutroumpakis",
            affiliation:
              "Albany Medical College; University of Pittsburgh Medical Center",
            country: "USA",
          },
          {
            name: "Kivanc Gorgulu",
            affiliation:
              "Klinikum rechts der Isar, Molekulare Gastroenterologie, Munich",
            country: "Germany",
          },
          {
            name: "Ioannis Drosos",
            affiliation:
              "Laboratory of Atherosclerosis Research, Democritus University of Thrace, Alexandroupolis",
            country: "Greece",
          },
          {
            name: "Alaa Abdelrahman Obeida",
            affiliation: "Kasr AlAiny Faculty of Medicine, Cairo",
            country: "Egypt",
          },
          {
            name: "Gergana Petrova-Georgieva",
            affiliation:
              "Clinic of Pediatric Diseases, UMHAT Georgi Stranski, Pleven",
            country: "Bulgaria",
          },
        ],
      },
    ],
  },
};

export function editorSlug(name) {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function allEditors() {
  const out = [];
  for (const [journalId, board] of Object.entries(EDITORIAL_BOARDS)) {
    for (const group of board.groups) {
      for (const m of group.members) {
        out.push({
          ...m,
          role: group.role,
          journalId,
          journalShort: board.journalShort,
          journalTitle: board.journalTitle,
          slug: editorSlug(m.name),
        });
      }
    }
  }
  return out;
}

export function getEditorBySlug(slug) {
  return allEditors().find((e) => e.slug === slug);
}

export function getBoard(journalId) {
  return EDITORIAL_BOARDS[journalId];
}

export function countMembers(journalId) {
  const b = EDITORIAL_BOARDS[journalId];
  if (!b) return 0;
  return b.groups.reduce((acc, g) => acc + g.members.length, 0);
}

export function uniqueCountries(journalId) {
  const b = EDITORIAL_BOARDS[journalId];
  if (!b) return [];
  const s = new Set();
  for (const g of b.groups) for (const m of g.members) s.add(m.country);
  return Array.from(s);
}
